var map = {
	"./ages-branco.svg": "4b0c",
	"./ages.svg": "03e6",
	"./anima.svg": "94db",
	"./fadergs-branco.svg": "8d26",
	"./fadergs.svg": "0108",
	"./faseh-branco.svg": "fd4b",
	"./faseh.svg": "ea1f",
	"./fpb-branco.svg": "947f",
	"./fpb.svg": "665f",
	"./ibmr-branco.svg": "ffc8",
	"./ibmr.svg": "0172",
	"./mcampos-branco.svg": "9b4c",
	"./mcampos.svg": "f900",
	"./sociesc-branco.svg": "f2d7",
	"./sociesc.svg": "061d",
	"./uam-branco.svg": "1310",
	"./uam.svg": "b2c8",
	"./una-branco.svg": "10ed",
	"./una.svg": "783c",
	"./unibh-branco.svg": "1327",
	"./unibh.svg": "dfa2",
	"./unicuritiba-branco.svg": "78fb",
	"./unicuritiba.svg": "6af0",
	"./unifacs-branco.svg": "f45b",
	"./unifacs.svg": "a375",
	"./unifg-branco.svg": "4b70",
	"./unifg.svg": "d755",
	"./unifgua-branco.svg": "1f63",
	"./unifgua.svg": "5149",
	"./uniritter-branco.svg": "5a6b",
	"./uniritter.svg": "69dc",
	"./unisul-branco.svg": "8ef5",
	"./unisul.svg": "3ebe",
	"./unp-branco.svg": "6e89",
	"./unp.svg": "177b",
	"./usjt-branco.svg": "3f92",
	"./usjt.svg": "8de4"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "5047";